import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ItemMenu } from '../dominios/item-menu';
import { Sistema } from '../dominios/sistema';
import { BACK_END_CONTROLE_ACESSO } from './../../../app.constants';

@Injectable()
export class PermissaoModulosService {


  constructor(protected http: HttpClient) { }

  getSistemaByCdCentrusTpSistemaSgSistema(cdCentrus, tpSistema, sgSistema) {
    return this.http
      .get<Sistema>(`${BACK_END_CONTROLE_ACESSO}gerenPerm/sistema-usuario-logado/${cdCentrus}/${tpSistema}/${sgSistema}`)
      .toPromise();
  }


  getItemMenuByCdCentrusAndIdSistema(cdCentrus, idSistema) {
    return this.http
      .get<ItemMenu[]>(`${BACK_END_CONTROLE_ACESSO}gerenPerm/item-menu/${cdCentrus}/${idSistema}`)
      .toPromise();
  }



  getOperadorItemMenuByCdCentrusAndIdSistema(idSistema, cdCentrus) {
    return this.http
      .get<ItemMenu[]>(`${BACK_END_CONTROLE_ACESSO}gerenPerm/oper-item-menu-sist-permissoes/${idSistema}/${cdCentrus}`)

      .toPromise();
  }


  getValidarPermissoesItemMenu(cdCentrus, dsUrl, regra) {
    return this.http
      .get<Boolean>(`${BACK_END_CONTROLE_ACESSO}gerenPerm/validar-permissoes/${cdCentrus}/${dsUrl}/${regra}`)
      .toPromise();
  }

  getByOperItemMenu(cdCentrus, idItemMenu, idSistema) {
    return this.http.get(`${BACK_END_CONTROLE_ACESSO}gerenPerm/oper-item-menu/${cdCentrus}/${idItemMenu}/${idSistema}`);
  }

  getListaSistemas(cdCentrus, tipoSistema) {
    return this.http.get<Sistema[]>(`${BACK_END_CONTROLE_ACESSO}gerenPerm/sistema/tipoSistema/${cdCentrus}/${tipoSistema}`)
      .toPromise();
  }

  getConfirmarCredenciais(username) {
    return this.http.get(`${BACK_END_CONTROLE_ACESSO}gerenPerm/analise/${username}`);
  }

  getConfirmaPlanoPessoa(cdCentrus) {
    return this.http.get(`${BACK_END_CONTROLE_ACESSO}gerenPerm/tipoPlano/${cdCentrus}`)
      .toPromise();
  }

  getItemMenuPaiIdSistema(idSistema, cdCentrus) {
    return this.http.get<ItemMenu[]>(`${BACK_END_CONTROLE_ACESSO}gerenPerm/item-menu-pai/${idSistema}/${cdCentrus}`)
      .toPromise();
  }

  getBySgGrupoAcesso(cdCentrus, sgGrupoAcesso) {
    return this.http.get<Boolean>(`${BACK_END_CONTROLE_ACESSO}gerenPerm/grupo-acessos/verificar-por-sigla/${cdCentrus}/${sgGrupoAcesso}`)
      .toPromise();
  }

}






// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/services/permissoes-modulos.service .ts